import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { MqDesktop } from 'streamr-ui/css/consts'
import Link from '~shared/Link'

const UnstyledSocialLinks = forwardRef(function UnstyledSocialLinks(
    { className, email, linkedin, twitter, website, style },
    ref,
) {
    return (
        <div className={className} ref={ref} style={style}>
            {twitter && (
                <Link href={twitter} newTab>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            // eslint-disable-next-line max-len
                            d="M8.654 19.5c6.793 0 10.51-5.773 10.51-10.77 0-.163 0-.325-.008-.487A7.632 7.632 0 0 0 21 6.279a7.345 7.345 0 0 1-2.125.598 3.793 3.793 0 0 0 1.628-2.096 7.24 7.24 0 0 1-2.348.915A3.646 3.646 0 0 0 15.46 4.5c-2.038 0-3.695 1.698-3.695 3.787 0 .295.036.583.094.864-3.069-.155-5.792-1.669-7.614-3.957a3.858 3.858 0 0 0-.497 1.904c0 1.314.656 2.473 1.642 3.152a3.667 3.667 0 0 1-1.67-.472v.052c0 1.83 1.274 3.366 2.96 3.713a3.52 3.52 0 0 1-.973.133 3.49 3.49 0 0 1-.691-.067c.468 1.506 1.837 2.599 3.45 2.628A7.295 7.295 0 0 1 3 17.81a10.322 10.322 0 0 0 5.654 1.69"
                            fill="currentColor"
                        />
                    </svg>
                </Link>
            )}
            {linkedin && (
                <Link href={linkedin} newTab>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            // eslint-disable-next-line max-len
                            d="M9 19.136S9.05 8.612 9 7.523h3.851v1.684h-.025c.506-.793 1.418-1.957 3.496-1.957 2.534 0 4.434 1.66 4.434 5.227v6.659h-3.851v-6.213c0-1.561-.557-2.627-1.951-2.627-1.064 0-1.698.719-1.976 1.413-.102.247-.127.594-.127.941v6.486H9zM5.153 6.013h-.025C3.836 6.013 3 5.121 3 4.006 3 2.867 3.861 2 5.179 2c1.317 0 2.128.867 2.153 2.006 0 1.115-.836 2.007-2.179 2.007zM3.228 19.211V7.598h3.85v11.613h-3.85z"
                            fill="currentColor"
                            fillRule="evenodd"
                        />
                    </svg>
                </Link>
            )}
            {website && (
                <Link href={website} newTab>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            // eslint-disable-next-line max-len
                            d="M7.82 19.508A7.943 7.943 0 0 1 4.812 16.5H7.82v3.008zm8.36 0V16.5h3.008a7.943 7.943 0 0 1-3.008 3.008zm-1.68.742c-.781.273-1.64.39-2.5.39-.86 0-1.719-.117-2.5-.39V16.5h5v3.75zM7.82 5.133V8.14H4.812A7.943 7.943 0 0 1 7.82 5.133zm8.36 0a7.943 7.943 0 0 1 3.008 3.008H16.18V5.133zM9.5 4.352A8.788 8.788 0 0 1 12 4c.86 0 1.719.117 2.5.352V8.14h-5V4.35zm8.438 6.093h-.977l-.469 1.875-.469-1.836.04-.039h-.977l-.938 3.75-.937-3.71v-.04h-.977l-.43 1.875-.468-1.836v-.039h-.977l-.937 3.75-.938-3.71v-.04h-.976l-.43 1.875-.469-1.836v-.039h-.976l-.938 3.75h.977l.43-1.836.468 1.836h.977l.469-1.836.43 1.836h1.913l.47-1.836.468 1.836h.976l.47-1.836.429 1.836h1.914l.469-1.836.468 1.836H17l.469-1.836.43 1.836h.976l-.938-3.71v-.04zm3.242 5.196H2.82a.825.825 0 0 1-.82-.82v-5C2 9.35 2.39 9 2.82 9h18.36c.43 0 .82.352.82.82v5c0 .47-.39.82-.82.82z"
                            fill="currentColor"
                        />
                    </svg>
                </Link>
            )}
            {email && (
                <a href={`mailto:${email}`}>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            // eslint-disable-next-line max-len
                            d="M12.475 13.065l8.523-5.29L21 7.8v8.1c0 .992-.807 1.8-1.8 1.8H4.8c-.992 0-1.8-.808-1.8-1.8V7.8c0-.008.003-.016.003-.025l8.522 5.29a.904.904 0 0 0 .95 0zM12 11.24L3.931 6.233A1.79 1.79 0 0 1 4.8 6h14.4c.317 0 .61.09.869.233L12 11.241z"
                            fill="currentColor"
                            fillRule="evenodd"
                        />
                    </svg>
                </a>
            )}
        </div>
    )
})

const SocialLinks = styled(UnstyledSocialLinks)`
    color: #cecece;

    ${({ desktop }) =>
        !!desktop &&
        css`
            display: none;

            @media ${MqDesktop} {
                display: flex;
            }
        `}

    ${({ mobile }) =>
        !!mobile &&
        css`
            display: flex;

            @media ${MqDesktop} {
                display: none;
            }
        `}

    > a + a {
        margin-left: 0.75rem;
    }

    svg {
        color: #cecece;
        cursor: pointer;
        display: block;
        transition: color 0.1s ease;
        width: 1.5rem;
    }

    svg:hover {
        color: #adadad;
    }
`

export default SocialLinks
